import { Me } from '@/hooks/api/models';
import axios from '@/lib/axios';
import { useMutation } from '@tanstack/react-query';

/**
 * 0120. プロフィール変更
 * [PUT] /me
 */
type Props = {
  name: string;
  icon_file: string;
};

const updateProfile = (props: Props): Promise<Me> => {
  return axios.put('/api/me', props);
};

export const useUpdateProfile = () => {
  return useMutation({
    mutationFn: updateProfile
  });
};